import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { RptActivacionComponent } from './rpt-activacion/rpt-activacion.component';
import { RptSaldoComponent } from './rpt-saldo/rpt-saldo.component';

const routesRpt: Routes = [
    { path: 'rpt-activacion', component: RptActivacionComponent, canActivate: [AuthGuard] },
    { path: 'rpt-saldo', component: RptSaldoComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routesRpt)],
    exports: [RouterModule],
})
export class RptRoutingModule { }
